import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
const Login = () => import('./views/Login.vue');
const CreateAccount = () => import('./views/CreateAccount.vue');
const ForgotPassword = () => import('./views/ForgotPassword.vue');
const ResetPassword = () => import('./views/ResetPassword.vue');
const PermitApplication = () => import('./views/PermitApplication.vue');
const ApplicationSubmitted = () => import('./views/ApplicationSubmitted.vue');
const ConfirmAccount = () => import('./views/ConfirmAccount.vue');
const Maintenance = () => import('./views/Maintenance.vue');
const Dashboard = () => import('./views/Dashboard.vue');
// import Login from './views/Login.vue';
// import CreateAccount from './views/CreateAccount.vue';
// import ForgotPassword from './views/ForgotPassword.vue';
// import ResetPassword from './views/ResetPassword.vue';
// import PermitApplication from './views/PermitApplication.vue';
// import ApplicationSubmitted from './views/ApplicationSubmitted.vue';
// import ConfirmAccount from './views/ConfirmAccount.vue';
// import Maintenance from './views/Maintenance.vue';

Vue.use(Router);

// guard functions, just add the appropriate one to beforeEnter hook for the route you want to guard

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next('/login');
        return;
    }
    next();
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next('/');
        return;
    }

    next();
};

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component:
                process.env.VUE_APP_MAINT == 'true' ? Maintenance : Login,
            beforeEnter: ifAuthenticated,
        },

        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/create-account',
            name: 'Create account',
            component: CreateAccount,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/forgot-password',
            name: 'Forgot password',
            component: ForgotPassword,
        },
        {
            path: '/passwordreset',
            name: 'Reset password',
            component: ResetPassword,
        },
        {
            path: '/emailconfirmation',
            name: 'Confirm account',
            component: ConfirmAccount,
        },
        {
            path: '/application',
            name: 'New application',
            component: PermitApplication,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/application-submitted',
            name: 'Application submitted',
            component: ApplicationSubmitted,
            beforeEnter: ifNotAuthenticated,
        },
        { path: '*', name: 'root', redirect: '/application' },
    ],
});

// If the user's token is about to expire, have them relog to renew it.
// Global route guard
router.beforeEach((to, from, next) => {
    //console.log(store);
    //console.log('isloggedIn: ' + store.getters["isLoggedIn"] + '...loggedinUser: ' + Object.keys(store.getters["getUser"]).length);
    // If the user is resetting a password or confirming an account email, don't intercept the route
    if (['Reset password', 'Confirm account'].includes(to.name)) {
        next();
    }

    // If the user isn't logged in and there's no valid token, push to login
    //Bkup: if (!store.getters.isLoggedIn) next();
    if (!store.getters["isLoggedIn"]) next();

    const token = JSON.parse(sessionStorage.getItem('access_token'));

    // If a token was found, check if it's valid and if we have user
    // All units are modified to be in seconds
    if (token) {
        const [expires, timeSinceCreated] = [
            token.expires_in - 600 || null,
            (Date.now() - token.created_time) / 1000 || null,
        ];

        // If the token exists and is expired, log them out
        if (token !== null && timeSinceCreated > expires) {
            // logout and relog
            store.dispatch('USER_LOGOUT').then(() => next('/login?expired'));
        }

        // If the token is valid but there's no user logged in, log them in. If the login fails, fall back on relogging 
        if (
            token !== null &&
            timeSinceCreated < expires &&
            //Bkup: Object.keys(store.getters.getUser).length == 0
            Object.keys(store.getters["getUser"]).length == 0
        ) {
            store
                .dispatch('USER_LOGIN', token.access_token)
                //.then(() => next('/application'))
                //BKUP:.then(() => next('/dashboard'))
                .then(() => {
                    if(store.getters.formDataWasRecovered)
                    {
                        next('/application');
                    }   
                    else   
                    {
                        next('/dashboard');
                    } 
                        
                })
                .catch(() => {
                    store.dispatch('USER_LOGOUT').then(() => next());
                });
        }
    }

    next();
});

export { router };
